import axios from "axios";

const metaCsrfToken = document.querySelector('meta[name="csrf-token"]');
const csrfTokenValue = metaCsrfToken ? metaCsrfToken.getAttribute("content") : '';

export default axios.create({
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": csrfTokenValue
    }
});
